

export class MetadataElement {
  constructor(data, schemaKey, label, level = 0, branchIsLabeled = false) {
    this.key = schemaKey;
    this.label = label;
    this.level = level;
    this.elements = null;
    this.elementsAsList = null;
    this.elementsAsTable = null;
    this.value = null;

    if (data instanceof Array) {
      let mergedBranch = this._mergeBranches(data, level, branchIsLabeled);
      this.elements = [mergedBranch];
    } else if (data instanceof Object) {
      let filteredData = this._filterData(data);
      this.elements = this._getNextElements(filteredData, schemaKey, level, branchIsLabeled);
    } else {
      this.value = data;
    }
  }

  _getNextElements(filteredData, schemaKey, level, branchIsLabeled) {
    let elements = [];
    let schemaElementLabels = this._getSchemaElementLabels(schemaKey);
    let count = Object.keys(filteredData).length;
    for (var key in filteredData) {
      let nextElementLabel = schemaElementLabels[key];
      let nextElementIsLabeled = count > 1 ? !!nextElementLabel : (branchIsLabeled || !!nextElementLabel);

      if (!nextElementIsLabeled && this._canUseKeyAsLabel(key)) {
        nextElementLabel = key;
      }

      let nextElementLevel = nextElementLabel ? level + 1 : level;
      elements.push(new MetadataElement(filteredData[key], key, nextElementLabel, nextElementLevel, nextElementIsLabeled || !!nextElementLabel));
    }
    return elements;
  }

  _canUseKeyAsLabel(key) {
    const SCHEMA = (require('./schema.js').default).getInstance();
    let schema = SCHEMA[key];
    let type = (schema instanceof Object) && schema.type;
    return !schema || !type;
  }

  _filterData(data) {
    let filteredData = {};
    for (var key in data) {
      if (!this._ignore(key, data)) {
        filteredData[key] = data[key];
      }
    }
    return filteredData;
  }

  _getSchemaElementLabels(schemaKey) {
    const SCHEMA = (require('./schema.js').default).getInstance();
    let schemaElementLabels = {};
    let getSchemaElementLabels = (schemaKey, acc) => {
      let schema = SCHEMA[schemaKey];
      if (schema instanceof Object) {
        if (schema.base) {
          getSchemaElementLabels(schema.base, acc);
        }
        if (schema.type) {
          getSchemaElementLabels(schema.type, acc);
        }
        if (schema.elements) {
          for (var key in schema.elements) {
            acc[key] = schema.elements[key];
          }
        }
      }
    }
    getSchemaElementLabels(schemaKey, schemaElementLabels);
    return schemaElementLabels;
  }

  _ignore(key, data) {
    if (key === '@xsi:type' || key === '@codeSpace' || key === '@codeList' || (key && (key.startsWith('@xmlns:')))) {
      return true;
    }
    if (key === '#text' && data['@codeListValue']) {
      return true;
    }
    return false;
  }

  _mergeBranches(dataArray, level, branchIsLabeled) {
    let elementArray = dataArray.map(x => {
      return new MetadataElement(x, null, null, level, branchIsLabeled);
    });

    let branchFirstElement = elementArray[0];
    let branchLastElement = branchFirstElement;
    let labelDict = {};
    let tableItems = [];
    let listItems = [];
    let fork = null;

    while (!fork) {
      let nextBranchLastElement = elementArray[0];
      let nextElementArray = [];

      elementArray.forEach(element => {
        if (this._isFork(nextBranchLastElement, element)) {
          fork = element;
        }

        if (element.elements) {
          nextElementArray.push(element.elements[0]);
        }
      });

      branchLastElement.elements = [nextBranchLastElement];

      if (nextBranchLastElement.elements) {
        branchLastElement = nextBranchLastElement;
      }

      if (!fork) {
        elementArray = nextElementArray;
      }
    }

    if (elementArray) {
      elementArray.forEach(element => {
        if (element.elements) {
          let row = {};
          element.elements.forEach(x => {
            labelDict[x.key] = x.label;
            x.label = null;
            row[x.key] = x;
          });
          tableItems.push(row);
        } else {
          listItems.push(element);
        }
      });
    }

    let fields = Object.keys(labelDict).map(x => {
      return {
        key: x,
        label: labelDict[x]
      }
    });

    if (fields.length === 0) {
      branchLastElement.elementsAsList = listItems;
    } else {
      branchLastElement.elementsAsTable = {
        fields: fields,
        items: tableItems
      };
    }

    return branchFirstElement;
  }

  _isFork(elementA, elementB) {
    return elementA.key !== elementB.key || !elementB.elements || elementB.elements.length !== 1
  }
}
